module.exports = __webpack_public_path__ + "components/flag/static/square/mn-8bdd92fddd40b932083a4c5402a82c70.svg";